<template>
	<aside>
		<div class="section-data" style="min-height: 400px;">
			<div class="title d-flex justify-content-between">
				<div class="text">
					<div id="slot-title">
					</div>
					<h3 class="font-blue">Contenido</h3>
					<p class="font-gray-dark">Contenido general del curso</p>
				</div>
				<div class="tools">
					<div id="slot-tools">
					</div>
				</div>
			</div>
			<div class="data">
				<div class="container my-3">
					<div id="slot-content">
					</div>
					<div class="content">
						<div class="target-downloading text-center p-1 font-gray-dark" v-if="downloading">
							<b-spinner small label="Espere ..."></b-spinner>
							<span class="p-1">Espere un momento...</span>
						</div>
						<div class="target-body pb-5" v-if="!downloading">


							<p class="font-gray-dark font-weight-bold">Sube contenido introductorio de tu curso, puedes
								subir imágenes, videos o PDF's. El
								contenido que subas
								es solo para mostrar o informar sobre tu curso. No se aceptan archivos formato word ni
								excel.
							</p>


							<FilePond ref="files_upload"
									  :label-idle="labelFiles"
									  :disabled="downloading"
									  :files="filesExists"
									  allow-multiple="true"
									  @addfile="addFile"
									  @removefile="removeFile"
									  max-files="6"/>

							<div v-if="uploadErrors" class="alert alert-danger mt-3 mb-5">
								{{ uploadErrors }}
							</div>
							<br> 
							<button @click="upload" class="btn b-blue " v-if="files.length > 0">
								<span v-if="filesExists.length > 0">
								  Actualizar contenido
								</span>
								<span v-else>
								  Agregar al curso
								</span>
							</button>
							<router-link to="publish" class="mt-5 mb-5">
								<button class="btn font-orange ">
									Publicar curso <i class="fas fa-arrow-right"></i>
								</button>
							</router-link>
						</div>
					</div>
				</div>
			</div>
		</div>
	</aside>


</template>
<script>
import vueFilePond from 'vue-filepond'; 

const FilePond = vueFilePond();

export default {
	components: {
		FilePond
	},
	data() {
		return {
			downloading: false,
			newVideo: false,
			videos: {},
			files: [],
			filesExists: [],
			uploadErrors: null,
			uploading: true,
			carga:0
		}
	},
	methods: {
		getVideosUploaded() {

			let id = this.$route.params.id
			if (id != undefined) {
				this.newVideo = false
				this.downloading = true
				this.api.get('course/find/' + id).then(({data}) => {

					let files_old = [];

					data.data.media_content.forEach((file) => {
						let item = {
							source: file.content,
							options: {
								file: {
									name: file.name,
									size: 3001025,
									old: true,
									model: file,
								}
							}
						}
						files_old.push(item)
					})

					this.filesExists = files_old

					this.downloading = false
				}).catch(err => {

				});
			}
		},
		removeVideoElement(key) {
			this.$delete(this.videos.data, key)
		},
		addFile() {

			var files = [];

			this.$refs.files_upload.getFiles().forEach((item) => {
				let ext = item.file.name.split(".").pop();
				if (ext === "mp4" || ext === "mov" || ext === "png" || ext === "jpg" || ext === "jpeg" || ext === "pdf") {
					files.push(item.file)
				} else {
					this.toast('No se aceptan archivos con ese formato', 'warning')
					this.$refs.files_upload.removeFile(item.id);
				}
			})

			this.files = files

			this.uploading = false
		},
		removeFile() {

			var files = [];

			this.$refs.files_upload.getFiles().forEach((item) => {
				files.push(item.file)
			})

			this.files = files

		},
		upload() {

			let id = this.$route.params.id
			if (id != undefined) {
				const fd = new FormData();

				var old_files = [];

				this.files.forEach((file) => {

					if (file.old) {
						old_files.push(file.model)
					} else {
						fd.append('file[]', file)
					}

				})

				fd.append('olds', JSON.stringify(old_files))

				this.uploadErrors = null;

				this.downloading = true

				this.api.post('course/uploadContent/' + id, fd).then(({data}) => {
					this.toast("Tus archivos se han subido con éxito")
					this.downloading = false
					this.uploading = true
					this.carga = 1;
					this.getVideosUploaded(id)
				}).catch((err) => {
					this.uploadErrors = err.response.data.errors
					this.downloading = false
				})
			}

		},
		toast(message, variant = 'success') {
			this.$bvToast.toast(message, {
				title: "Kllaar.com",
				variant: variant,
				toaster: 'b-toaster-bottom-right',
				solid: true,
				appendToast: true
			})
		}
	},
	created() {
		let id = this.$route.params.id
		this.carga = 0;
		if (id != undefined) {
			this.getVideosUploaded(id)
		}
	},
	computed: {
		labelFiles() {
			return "Da click aqui para agregar tus archivos máximo 6 archivos, " +
				(6 - this.files.length) + " restantes.";
		}
	}
}
</script>
<style lang="scss">
.target {
	margin-top: 0;
}

.section {
	&-data {
		background: #fff !important;
		-webkit-box-shadow: 0 .125rem .25rem rgba(0, 0, 0, .075) !important;
		box-shadow: 0 .125rem .25rem rgba(0, 0, 0, .075) !important;
		border-radius: .25rem !important;

		.title {
			padding: 15px 0 0 15px;
			border-bottom: 1px solid #EEEEEE;
		}

		.data {
			.is-empty, .is-loading {
				text-align: center;
				justify-content: center;
				align-content: center;

				img {
					opacity: .5;
				}
			}
		}
	}
}
</style>




// WEBPACK FOOTER //
// src/components/#pages/curses/pages/Content2.vue